export const SAMPLE_MRZ = 'P<UTOERIKSSON<<ANNA<MARIA<<<<<<<<<<<<<<<<<<<HA672242<6UTO5802254F9501083<<<<<<<<<<<<<<08';
export const SAMPLE_MRZ_UPPER = 'P<UTOERIKSSON<<ANNA<MARIA<<<<<<<<<<<<<<<<<<<';
export const SAMPLE_MRZ_LOWER = 'HA672242<6UTO5802254F9501083<<<<<<<<<<<<<<08';
